import qs from "qs";

import StateApi from "../../services/api/State";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import { getPath } from "../../utils";

function handleError(err) {
  console.log("error in state actions:", err);
}

export const setStateList = (payload) => {
  return {
    type: ActionTypes.SET_STATE_LIST,
    payload,
  };
};

export const setCurrentPageState = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_STATE,
    payload,
  };
};

export const getStateList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
      };
      if (getPath(filters, "startswith.length", -1) > 0) {
        finalPayload["startswith"] = filters.startswith;
        delete filters.startswith;
      }

      if (Object.keys(filters).length > 0) {
        Object.keys(filters).map((key) => {
          finalPayload[key] = [filters[key]];
        });
      }
      if (filters["name"]) {
        finalPayload["startswith"] = filters["name"];
        delete finalPayload.name;
      }

      const queryString = qs.stringify(finalPayload);
      dispatch(setLoader(true));
      let response = await StateApi.getStateList(queryString);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setStateList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPageState(getPath(pageRequest, "page", 1)));
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getBulkStates = (stateIds) => async (dispatch) => {
  try {
    var states = [];
    dispatch(setLoader(true));
    for (const id of stateIds) {
      let finalPayload = {
        id: id,
      };
      let response = await StateApi.getState(finalPayload);
      if (response) {
        states = [...states, getPath(response, "state", {})];
      }
    }
    dispatch(setLoader(false));
    return states;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const setActiveState = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_STATE,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_STATE_FILTERS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_STATE,
    payload,
  };
};

export const getState = (id) => async (dispatch) => {
  try {
    let finalPayload = {
      id: id,
    };
    dispatch(setLoader(true));
    let response = await StateApi.getState(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      const stateObj = getPath(response, "state", {});
      dispatch(setActiveState(stateObj));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createState = (data) => async (dispatch) => {
  try {
    let finalPayload = { state: data };
    dispatch(setLoader(true));
    let response = await StateApi.createState(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(resetState({ state: "activeState" }));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateState = (id, data) => async (dispatch) => {
  try {
    const finalPayload = {
      state: data,
    };
    dispatch(setLoader(true));
    const response = await StateApi.updateState(id, finalPayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(resetState({ state: "activeState" }));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
